var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaseb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_6758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6885 16.1987C21.9295 17.0947 21.5156 18.2186 21.5156 19.4063C21.5156 20.5926 21.9371 21.7266 22.6921 22.6183C23.5011 21.7909 23.9999 20.659 23.9999 19.4104C23.9999 18.16 23.4996 17.0265 22.6885 16.1987Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0976 22.5872C16.8423 21.6956 17.248 20.5821 17.248 19.4062C17.248 18.2372 16.8372 17.1165 16.1011 16.23C15.308 17.0549 14.8203 18.1756 14.8203 19.4104C14.8203 20.6433 15.3065 21.7625 16.0976 22.5872Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5661 23.4631C20.6309 22.3293 20.1095 20.9004 20.1095 19.4064C20.1095 17.9108 20.6209 16.494 21.5607 15.3551C20.9191 15.0142 20.1873 14.8208 19.4102 14.8208C18.6168 14.8208 17.8705 15.0221 17.2194 15.3765C18.1408 16.5065 18.6544 17.9261 18.6544 19.4064C18.6544 20.8954 18.1476 22.3064 17.2158 23.4427C17.8677 23.7982 18.6153 24.0003 19.4102 24.0003C20.1895 24.0003 20.9233 23.8058 21.5661 23.4631Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.237 0.763695C22.2194 -0.253914 20.5696 -0.253914 19.552 0.763695L14.8915 5.4242C14.3248 5.99082 13.7817 6.58037 13.2632 7.19138L10.0745 11.3824C9.65066 11.9394 9.20755 12.4816 8.74311 13.0053C8.4297 13.3586 8.11161 13.7077 7.78906 14.0527L9.94808 16.2117C10.293 15.8892 10.6422 15.5711 10.9955 15.2577C11.519 14.7932 12.0612 14.3501 12.6183 13.9263L16.8094 10.7376C17.4204 10.2191 18.0099 9.67595 18.5765 9.10932L23.237 4.44882C24.2547 3.43116 24.2547 1.7813 23.237 0.763695Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81524 15.0674C6.7139 15.1704 6.61246 15.2733 6.51032 15.3754L3.59863 18.2871C3.89057 18.4447 4.16132 18.6455 4.40249 18.8867L5.11373 19.5979C5.35495 19.8391 5.55571 20.1099 5.71335 20.4018L8.62504 17.4901C8.72723 17.3879 8.83012 17.2865 8.9331 17.1852L6.81524 15.0674Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17991 23.8904L0.109828 20.8203C-0.0366094 20.6739 -0.0366094 20.4364 0.109828 20.29L0.518719 19.8811C1.31653 19.0833 2.61005 19.0833 3.40786 19.8811L4.11909 20.5924C4.91691 21.3902 4.91691 22.6837 4.11909 23.4815L3.7102 23.8904C3.56381 24.0368 3.32634 24.0368 3.17991 23.8904Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_6758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseb);
export default __webpack_public_path__ + "static/media/BASEB.31ab581f647d674c8111568981b95a26.svg";
export { ForwardRef as ReactComponent };